import { IoPint, IoWine } from "react-icons/io5";
import "./navbar.css";

const Navbar = () => {
  return (
    <div class="navbar">
      <div class="navbar-menu">
        <div class="navbar-menu__logo">
          <img src="./img/monsty-logo.svg" alt="Logo" />
        </div>
        <div class="navbar-menu__right-items">
          <ul>
            <li><a href="/menu"><IoPint /><IoWine /></a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;